import { render } from "./user-security.vue?vue&type=template&id=6bd355cc&ts=true"
import script from "./user-security.vue?vue&type=script&lang=ts"
export * from "./user-security.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__